import { Box, Button, Stack, Typography } from "@mui/material";

interface AnimalLiabilityProps {
  closeModal(): void;
}

export function AnimalLiability({ closeModal }: AnimalLiabilityProps) {
  return (
    <Stack spacing={4}>
      <Box>
        <Typography>
          The animal liability exclusion removes all liability coverage caused
          by or contributed by an animal regardless of whether you own the
          animal or not.
        </Typography>
      </Box>

      <Box>
        <Button onClick={closeModal}>Got it!</Button>
      </Box>
    </Stack>
  );
}
